import React, {useEffect, useRef, useState} from "react";
import {
    Typography,
    IconButton, Grid,
} from "@mui/material";
import {BottomSheet as BaseButtonSheet, BottomSheetProps as BaseBottomSheetProps} from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import {makeStyles} from "@mui/styles";
import {Dismiss} from "~/ui/icons";


export type SpringBottomSheetProps = {
    title?: any
    open: boolean
    onClose: () => void
    children?: any
}


const useStyles = makeStyles(() => ({
    backdrop: {
        zIndex: 1200,
    },
    sheet: {
        position: "absolute",
        zIndex: 1200,
        "& [data-rsbs-header]": {
            padding: 0,
            display: "flex",
            alignItems: "center",
            boxShadow: "none",
            "&:before": {
                display: "none",
            }
        },
        "& [data-rsbs-overlay]": {
            borderRadius: "16px 16px 0 0"
        }
    },
    title: {
        color: "#000000"
    },
    knob: {
        width: 46,
        height: 3,
        borderRadius: 3,
        backgroundColor: "#DADDE2"
    }
}))


export const SpringBottomSheet = (props: SpringBottomSheetProps) => {
    const {title, children, open, onClose} = props;
    const classes = useStyles(props);
    const firedClose = useRef<boolean>(false);
    const [showKnob, setShowKnob] = useState(false);

    useEffect(() => {
        if (!open) {
            firedClose.current = false;
        }
    }, [open]);

    const defaultSnap: BaseBottomSheetProps["defaultSnap"] = ({maxHeight, minHeight, ...other}) => {
        setShowKnob(minHeight == maxHeight);
        return Math.min(maxHeight / 3 * 2, minHeight);
    }

    const snapPoints: BaseBottomSheetProps["snapPoints"] = ({maxHeight, minHeight, ...other}) => {
        if (minHeight == maxHeight) {
            return [
                maxHeight,
                Math.min(maxHeight / 3 * 2, minHeight),
            ];
        }
        return [minHeight];
    }

    const handleDismiss = () => {
        // react-spring-bottom-sheet дважды вызывает событие при смазивании вниз
        if (!firedClose.current) {
            firedClose.current = true;
            onClose && onClose();
        }
    }

    return (
        <BaseButtonSheet
            className={classes.sheet}
            open={open}
            onDismiss={handleDismiss}
            defaultSnap={defaultSnap}
            snapPoints={snapPoints}
            expandOnContentDrag={true}
            blocking={true}
            skipInitialTransition={false}
            header={(
                <Grid container direction="column" wrap="nowrap">
                    {showKnob && (
                        <Grid item container alignItems="center" justifyContent="center" padding={1}>
                            <div className={classes.knob}/>
                        </Grid>
                    )}
                    <Grid item container wrap="nowrap" alignItems="center" padding="6px" paddingRight={1}>
                        <Typography align="center" variant="searchText" width="100%"
                                    className={classes.title}>
                            {title}
                        </Typography>
                        <IconButton onClick={onClose} color="primary">
                            <Dismiss/>
                        </IconButton>
                    </Grid>
                </Grid>
            )}
        >
            {children}
        </BaseButtonSheet>
    )
}
